import { render, staticRenderFns } from "./TransactionItemDetailPortal.vue?vue&type=template&id=4dd4a047&scoped=true&"
import script from "./TransactionItemDetailPortal.vue?vue&type=script&lang=ts&"
export * from "./TransactionItemDetailPortal.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionItemDetailPortal.vue?vue&type=style&index=0&id=4dd4a047&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4a047",
  null
  
)

export default component.exports